
<template>
    <FormulateForm
        :class="['form form--login', { 'form--error' : error }]"
        @submit="signUp"
        v-model="formFields"
    >
        <SVGlogo class="logo logo--lg hide--mob" />

        <transition name="fade-in" mode="out-in">
            <Alert type="error" v-if="error">
                {{ error }}
            </Alert>
        </transition>

        <FormulateInput
            class="form__group"
            label="Name"
            type="text"
            name="name"
            validation="required"
            autocomplete="given-name"
        >
            <template #label="{ label, id }">
                <label :for="id">
                    {{ label }}<span class="form--required" aria-label="required">*</span>
                </label>
            </template>
        </FormulateInput>

        <FormulateInput
            class="form__group"
            label="Email"
            type="email"
            name="email"
            validation="email"
            autocomplete="email"
        >
            <template #label="{ label, id }">
                <label :for="id">
                    {{ label }}<span class="form--required" aria-label="required">*</span>
                </label>
            </template>
        </FormulateInput>

        <FormulateInput
            class="form__group"
            label="Profession"
            type="text"
            name="profession"
            validation="required"
            autocomplete="off"
        >
            <template #label="{ label, id }">
                <label :for="id">
                    {{ label }}<span class="form--required" aria-label="required">*</span>
                </label>
            </template>
        </FormulateInput>

        <FormulateInput
            class="form__group"
            label="Password"
            type="password"
            name="password"
            validation="between:5,10,length"
            autocomplete="off"
        >
            <template #label="{ label, id }">
                <label :for="id">
                    {{ label }}<span class="form--required" aria-label="required">*</span>
                </label>
            </template>
        </FormulateInput>

        <FormulateInput
            v-model="agree"
            class="not-bold"
            :options="{agree: 'I agree to receiving ACEM email updates'}"
            type="customCheckbox"
        />

        <FormulateInput
            v-model="publicComputer"
            class="not-bold"
            :options="{publicComputer: `I'm using a public computer`}"
            type="customCheckbox"
            help="To protect your privacy, we'll log you out as soon as you close the browser."
        />

        <footer class="form__actions center">
            <FormulateInput
                :class="[
                    'btn--primary',
                    'btn--full',
                    { 'btn--loading' : loading }
                ]"
                :disabled="loading"
                type="submit"
                name="submit"
            >
                {{ signUpBtnLabel }} <Spinner v-if="loading" />
            </FormulateInput>

            <p>Already a member? <a href="#" @click.prevent="$emit('switchForm')">Login</a></p>
        </footer>
    </FormulateForm>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    data() {
        return {
            formFields: {},
            agree: false,
            publicComputer: false,
            error: null,
            loading: false,
        }
    },

    created () {
        console.log('from URL', this.$route.from)
    },

    computed: {
        signUpBtnLabel () {
            if (this.loading) return 'Signing Up...'
            return 'Sign Up'
        }
    },

    methods: {
        ...mapActions('Auth', ['loginUser']),

        signUp () {
            this.loading = true
            this.error = null

            const { name, email, password, profession } = this.formFields
            const { redirectFrom } = this.$route.query

            const user = {
                name,
                email,
                password,
                email_verified: true,
                connection: 'Username-Password-Authentication',
                verify_email: false,
                user_metadata: {
                    profession,
                    agreeToUpdates: this.agree
                }
            }

            // TODO: GET JWT TOKEN

            this.axios.post('/sign-up', { user })
                .then(async ({ data }) => {
                    if (data.error) throw new Error(data.message || data.error)
                    if (data.status === "fail") throw new Error(data.message.message || data.message.error)

                    await this.loginUser({ email, password, remember: !this.publicComputer })
                        .then(() => true)
                        .catch(error => {
                            throw new Error(error)
                        })
                })
                .then(() => {
                    if (redirectFrom) this.$router.push({ path: redirectFrom })
                    else this.$router.push({ name: 'dashboard' })
                })
                .catch(err => {
                    console.log(err.message || err)
                    this.error = err.message || err
                })
                .finally(() => { this.loading = false })
        }
    },
}
</script>

